<template>
  <div class="flex justify-center gap-4 mt-4">
    <div class="flex flex-col items-center gap-2 w-full">
      <!-- Pagination Info and Dropdown Row -->
      <div class="flex justify-between items-center w-full mb-2">
        <!-- Centered Pagination Info -->
        <div class="flex-1 text-center text-sm text-gray-700" v-if="totalItems">
          Showing {{ itemsPerPage }} items per page | Page {{ currentPage }} of
          {{ totalPages }} | Total Items: {{ totalItems }}
        </div>

        <!-- Right-Aligned Dropdown -->
        <div class="flex-shrink-0">
          <select
            v-model="selectedItemsPerPage"
            @change="pageSizeChange"
            class="text-sm bg-gray-100 border border-gray-300 rounded px-2 py-1 focus:ring-blue-500 focus:border-blue-500"
          >
            <option
              v-for="pageSize in pageSizes"
              :key="pageSize"
              :value="pageSize"
            >
              {{ pageSize }}
            </option>
          </select>
        </div>
      </div>

      <!-- Pagination Controls -->
      <div class="flex items-center gap-2">
        <!-- Previous Button -->
        <button
          :disabled="currentPage === 1"
          @click="previousPage"
          class="flex items-center gap-2 px-6 py-3 font-bold text-custom-blue align-middle transition-all rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Previous
        </button>

        <!-- Page Numbers -->
        <div class="flex items-center gap-2">
          <button
            v-for="page in totalPages"
            :key="page"
            :class="{
              'bg-custom-blue text-white': currentPage === page,
              'text-custom-blue': currentPage !== page,
            }"
            @click="goToPage(page)"
            class="relative h-10 w-10 max-w-[40px] rounded-lg text-center align-middle font-medium transition-all hover:bg-custom-blue hover:text-white"
          >
            {{ page }}
          </button>
        </div>

        <!-- Next Button -->
        <button
          :disabled="currentPage === totalPages"
          @click="nextPage"
          class="flex items-center gap-2 px-6 py-3 font-bold text-custom-blue align-middle transition-all rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaginationComponent",
  props: {
    currentPage: { type: Number, required: true },
    totalPages: { type: Number, required: true },
    itemsPerPage: { type: Number, default: 10 }, // Set default value to 10 }, // New prop for items per page
    totalItems: { type: Number }, // New prop for total items
  },
  data() {
    return {
      pageSizes: [10, 25, 50, 100],
      selectedItemsPerPage: this.itemsPerPage,
    };
  },
  methods: {
    previousPage() {
      if (this.currentPage > 1) {
        this.$emit("update:currentPage", this.currentPage - 1);
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.$emit("update:currentPage", this.currentPage + 1);
      }
    },
    goToPage(page) {
      if (page !== this.currentPage) {
        this.$emit("update:currentPage", page);
      }
    },
    pageSizeChange(pageSizeEvent) {
      const itemsPerPage = pageSizeEvent.target.value;
      if (itemsPerPage !== this.itemsPerPage) {
        this.$emit("update:changePageSize", itemsPerPage);
      }
    },
  },
};
</script>
